type IconProps = {
  color?: string;
  size?: number;
  className?: string;
};

/** For use in nav/sidebar: inherits text color and 20px size */
export function IconDashboardForNav({
  className,
}: {
  className?: string;
}) {
  return (
    <IconDashboard className={className} color="currentColor" size={20} />
  );
}

export function IconDashboard({
  color = "#3D3935",
  size = 26,
  className,
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M21.2647 1.35449H17.7354C17.3071 1.35448 16.9376 1.35447 16.6333 1.37933C16.3121 1.40558 15.9926 1.46352 15.6851 1.62017C15.2265 1.85386 14.8536 2.22675 14.6199 2.68539C14.4633 2.99283 14.4053 3.31232 14.3791 3.63353C14.3542 3.93786 14.3542 4.30734 14.3542 4.73563V8.26498C14.3542 8.69326 14.3542 9.06279 14.3791 9.36712C14.4053 9.68834 14.4633 10.0078 14.6199 10.3153C14.8536 10.7739 15.2265 11.1468 15.6851 11.3805C15.9926 11.5371 16.3121 11.5951 16.6333 11.6213C16.9376 11.6462 17.3071 11.6462 17.7354 11.6462H21.2647C21.6931 11.6462 22.0625 11.6462 22.3669 11.6213C22.6881 11.5951 23.0076 11.5371 23.315 11.3805C23.7737 11.1468 24.1466 10.7739 24.3802 10.3153C24.5369 10.0078 24.5948 9.68834 24.6211 9.36712C24.6459 9.06279 24.6459 8.6933 24.6459 8.265V4.73566C24.6459 4.30736 24.6459 3.93787 24.6211 3.63353C24.5948 3.31232 24.5369 2.99283 24.3802 2.68539C24.1466 2.22675 23.7737 1.85386 23.315 1.62017C23.0076 1.46352 22.6881 1.40558 22.3669 1.37933C22.0625 1.35447 21.693 1.35448 21.2647 1.35449Z"
          fill={color}
        />
        <path
          d="M8.26473 14.3545H4.73543C4.30715 14.3545 3.93762 14.3545 3.63329 14.3793C3.31207 14.4056 2.99258 14.4635 2.68515 14.6202C2.2265 14.8539 1.85361 15.2267 1.61992 15.6854C1.46328 15.9928 1.40533 16.3123 1.37909 16.6335C1.35422 16.9379 1.35423 17.3073 1.35425 17.7356V21.265C1.35423 21.6933 1.35422 22.0628 1.37909 22.3671C1.40533 22.6883 1.46328 23.0078 1.61992 23.3153C1.85361 23.7739 2.2265 24.1468 2.68515 24.3805C2.99258 24.5371 3.31207 24.5951 3.63329 24.6213C3.93763 24.6462 4.30711 24.6462 4.73542 24.6462H8.26475C8.69305 24.6462 9.06254 24.6462 9.36688 24.6213C9.68809 24.5951 10.0076 24.5371 10.315 24.3805C10.7737 24.1468 11.1466 23.7739 11.3802 23.3153C11.5369 23.0078 11.5948 22.6883 11.6211 22.3671C11.6459 22.0628 11.6459 21.6933 11.6459 21.265V17.7357C11.6459 17.3074 11.6459 16.9379 11.6211 16.6335C11.5948 16.3123 11.5369 15.9928 11.3802 15.6854C11.1466 15.2267 10.7737 14.8539 10.315 14.6202C10.0076 14.4635 9.68809 14.4056 9.36688 14.3793C9.06255 14.3545 8.69302 14.3545 8.26473 14.3545Z"
          fill={color}
        />
        <path
          d="M8.26473 1.35449H4.73543C4.30714 1.35448 3.93762 1.35447 3.63329 1.37933C3.31207 1.40558 2.99258 1.46352 2.68515 1.62017C2.2265 1.85386 1.85361 2.22675 1.61992 2.68539C1.46328 2.99283 1.40533 3.31232 1.37909 3.63353C1.35422 3.93787 1.35423 4.30735 1.35425 4.73565V8.26498C1.35423 8.69327 1.35422 9.06279 1.37909 9.36712C1.40533 9.68834 1.46328 10.0078 1.61992 10.3153C1.85361 10.7739 2.2265 11.1468 2.68515 11.3805C2.99258 11.5371 3.31207 11.5951 3.63329 11.6213C3.93763 11.6462 4.30711 11.6462 4.73542 11.6462H8.26475C8.69305 11.6462 9.06254 11.6462 9.36688 11.6213C9.68809 11.5951 10.0076 11.5371 10.315 11.3805C10.7737 11.1468 11.1466 10.7739 11.3802 10.3153C11.5369 10.0078 11.5948 9.68834 11.6211 9.36712C11.6459 9.06279 11.6459 8.6933 11.6459 8.265V4.73566C11.6459 4.30736 11.6459 3.93787 11.6211 3.63353C11.5948 3.31232 11.5369 2.99283 11.3802 2.68539C11.1466 2.22675 10.7737 1.85386 10.315 1.62017C10.0076 1.46352 9.68809 1.40558 9.36688 1.37933C9.06254 1.35447 8.69303 1.35448 8.26473 1.35449Z"
          fill={color}
        />
      </g>
      <path
        d="M19.5001 14.3545C16.6581 14.3545 14.3542 16.6584 14.3542 19.5003C14.3542 22.3423 16.6581 24.6462 19.5001 24.6462C22.342 24.6462 24.6459 22.3423 24.6459 19.5003C24.6459 16.6584 22.342 14.3545 19.5001 14.3545Z"
        fill={color}
      />
    </svg>
  );
}
